(ns common.schema.entities.kpi-report-answer
  (:require [common.schema.schema-utils :as su]
            [common.kpis :as kpis]))

(def schema
  (vec (concat (su/single-ref-field :kpi-report-answer/kpi-report "Report" [:entity.type/kpi-report] {:authorization su/access-user-ssg})
               (su/keyword-field :kpi-report-answer/question "Question" kpis/question-options {:authorization su/access-user-ssg})
               (su/text-multiline-field :kpi-report-answer/response "Response" {:authorization su/access-ssg-ssg})

               )))
